import React, { useState } from "react";
import "../FormProvComercializador/FormProvComercializador.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const FormAdminProv = () => {
  const navigate = useNavigate();
  const [User, setUser] = useState({
    nameAndLastName: "",
    cuit: "",
    email: "",
    placeOfResidence: "",
    street: "",
    numberStreet: "",
  });

  const formdataprov = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_COMPLETE_ADMIN_SUPPLIER}`,
        { User }
      );
      Swal.fire({
        icon: "success",
        title: "Bienvenido!",
        text: "Has completado tu perfil correctamente." || res.data.message,
      });
      navigate("/portal-admin-proveedor/inicio");
    } catch (error) {}
  };

  const handleNumericInputChange = (fieldName, value) => {
    // Filtrar caracteres no numéricos solo para CUIT, número y código postal
    let numericValue = value;
    if (["cuit", "numberStreet"].includes(fieldName)) {
      numericValue = value.replace(/[^0-9]/g, "");
    }
    setUser({ ...User, [fieldName]: numericValue });
  };

  return (
    <div className="allprov">
      <div className="allformprov">
        <p className="tittleformprv">Ingrese sus datos</p>
        <div className="dosplayinputProv">
          <div className="boxinputprov">
            <label className="labelformprov">Nombre Completo</label>
            <input
              className="inputupdateProv"
              type="text"
              value={User.nameAndLastName || ""}
              onChange={(e) =>
                setUser({ ...User, nameAndLastName: e.target.value })
              }
            />
          </div>
          <div className="boxinputprov">
            <label className="labelformprov">Cuit</label>
            <input
              className="inputupdateProv"
              type="text"
              maxLength={11}
              value={User.cuit || ""}
              onChange={(e) => handleNumericInputChange("cuit", e.target.value)}
            />
          </div>
        </div>
        <div className="dosplayinputProv">
          <div className="boxinputprov">
            <label className="labelformprov">Email</label>
            <input
              className="inputupdateProv"
              type="email"
              value={User.email || ""}
              onChange={(e) => setUser({ ...User, email: e.target.value })}
            />
          </div>
          <div className="boxinputprov">
            <label className="labelformprov">Lugar de residencia</label>
            <input
              className="inputupdateProv"
              type="text"
              value={User.placeOfResidence || ""}
              onChange={(e) =>
                setUser({ ...User, placeOfResidence: e.target.value })
              }
            />
          </div>
        </div>

        <div className="dosplayinputProv">
          <div className="boxinputprov">
            <label className="labelformprov">Calle</label>
            <input
              className="inputupdateProv"
              type="text"
              value={User.street || ""}
              onChange={(e) => setUser({ ...User, street: e.target.value })}
            />
          </div>
          <div className="boxinputprov">
            <label className="labelformprov">Numero</label>
            <input
              className="inputupdateProv"
              type="number"
              value={User.numberStreet || ""}
              onChange={(e) =>
                handleNumericInputChange("numberStreet", e.target.value)
              }
            />
          </div>
        </div>
        <div className="boxprovbutton">
          <button className="buttonprov" onClick={formdataprov}>
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormAdminProv;
